import { throwError as observableThrowError, BehaviorSubject, Observable } from 'rxjs';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { of, map } from 'rxjs';
import { HttpService } from './http.service';
import { TrackidleService } from './trackidle.service';
import { ToastrService } from 'ngx-toastr';
import { PlayerDetailResponse } from 'model/shared/backend-api-response/player-detail-response';
import { LoyalTokenResponse } from 'model/wbe/backend-api-response/loyal-token-response';

@Injectable()
export class CasinoPlayerService {
  private property_name: string;
  private server_name: string;
  private casioToken_server_name: string;
  private casinoToken_property_name: string;
  private tenantId: any;
  private propertyId: any;
  public errorMessage: string = '';
  userData$: BehaviorSubject<any>;
  validatesecondaryPlayers = new BehaviorSubject('default');
  resetPlayernew = new BehaviorSubject('default');
  thirdPartyGigyaLogin: boolean = false;
  primaryPlayerLoyaltyToken = '';
  primaryCasinoPlayerTokenInterval: any;

  constructor(
    private _http: HttpClient,
    public httpService: HttpService,
    private configservice: LegacyBookInitService,
    private router: Router,
    public trackService: TrackidleService,
    public toastr: ToastrService
  ) {
    this.tenantId = configservice.gettenantId();
    this.propertyId = configservice.getpropertyId();
    this.server_name = configservice.getserverDetails_loyalty();
    this.casioToken_server_name = configservice.getcasioToken_server_name();
    this.casinoToken_property_name = configservice.PropertyData.PropNameKeyList.validCasino;
    this.property_name = configservice.PropertyData.PropNameKeyList.loyalty;
    this.configservice.casinoSystemType.subscribe((isEnabled) => {
      this.thirdPartyGigyaLogin = isEnabled;
    });
    this.userData$ = new BehaviorSubject<any>('data');
  }

  updateCasinoPopUp(userData) {
    this.userData$.next(userData);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  async getCasinoPlayerDetails(casinoNo, tenantId, from?) {
    if (!this.thirdPartyGigyaLogin) {
      let token = this.primaryPlayerLoyaltyToken;
      if (from === 'load') {
        let newLoyaltyToken = await this.getLoyaltyToken('initial');
        token = this.primaryPlayerLoyaltyToken;
      }
      if (from && from != 'load') {
        token = from;
      }
      if (!this.configservice.PropertyData.casinoValReq) {
        token = '';
      }
      let header;
      let serviceHeaders = {};

      if (token) {
        serviceHeaders = { ...this.configservice.serviceHeaders?.headers, ...{ loyaltyToken: token } };
      } else {
        serviceHeaders = { ...this.configservice.serviceHeaders?.headers };
      }
      header = {
        headers: serviceHeaders,
      };
      let url1 =
        this.configservice.getCloudDomainName() +
        '/' +
        this.server_name +
        '/tenants/' +
        tenantId +
        ('/context/' + this.configservice.PropertyData.ContextId + '/') +
        'propertyName/' +
        this.property_name +
        '/loyaltyProgram/casino/loyaltyId/' +
        casinoNo +
        '?appName=wbe';
      return this.httpService.get(url1, header).toPromise();
    } else {
      let url2 =
        this.configservice.getCloudDomainName() +
        '/' +
        this.server_name +
        '/tenants/' +
        this.tenantId +
        ('/propertyId/' + this.propertyId) +
        '/playerId/' +
        casinoNo;

      console.log(url2);

      let responseToBeSent = {
        Success: true,
        ErrorMessage: '',
        addressLine1: '',
        addressLine2: '',
        cityName: '',
        countryCode: '',
        emailAddress: '',
        title: '',
        firstName: '',
        lastName: '',
        mobilePhoneNumber: '',
        phoneNumber: '',
        postalCode: '',
        rank: {
          isRankActive: false,
          lmsRankDescription: 'Rank',
          externalValue: '',
          lmsRank: '',
          lmsRankColor: ' ',
        },
        tier: {
          isTierActive: false,
          lmsTierDescription: 'Tier',
          externalValue: '',
          lmsTier: '',
          lmsTierColor: ' ',
        },
        gender: '',
        dob: '',
        state: '',
        vip: '',
      };

      return this.httpService
        .get(url2, this.configservice.serviceHeaders)
        .pipe(
          map((data: PlayerDetailResponse) => {
            if (data?.success) {
              responseToBeSent.addressLine1 = data?.playerDetail?.mailing_street ? data?.playerDetail?.mailing_street : '';
              responseToBeSent.cityName = data?.playerDetail?.mailing_city ? data?.playerDetail?.mailing_city : '';
              responseToBeSent.countryCode = data?.playerDetail?.mailing_country ? data?.playerDetail?.mailing_country : '';
              responseToBeSent.firstName = data?.playerDetail?.firstName ? data?.playerDetail?.firstName : '';
              responseToBeSent.lastName = data?.playerDetail?.lastName ? data?.playerDetail?.lastName : '';
              responseToBeSent.mobilePhoneNumber = data?.playerDetail?.MobilePhone || data?.playerDetail?.phone || '';
              responseToBeSent.phoneNumber = data?.playerDetail?.phone || data?.playerDetail?.MobilePhone || '';
              responseToBeSent.state = data?.playerDetail?.mailing_state ? data?.playerDetail?.mailing_state : '';
              responseToBeSent.tier.isTierActive = data?.playerDetail?.tier ? true : false;
              responseToBeSent.tier.lmsTier = data?.playerDetail?.tier ? data?.playerDetail?.tier : '';
              responseToBeSent.emailAddress = data?.playerDetail?.emailAddress ? data?.playerDetail?.emailAddress : '';
              responseToBeSent.postalCode = data?.playerDetail?.mailing_zip ? data?.playerDetail?.mailing_zip : '';
            } else {
              responseToBeSent.Success = false;
              responseToBeSent.ErrorMessage = data?.errorMessage;
            }
            return responseToBeSent;
          })
        )
        .toPromise();
    }
  }

  private errorHandle = (error) => {
    this.router.navigate(['/wbe/maintenance/' + this.tenantId + '/' + this.property_name]);
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };

  public ValidateCasinoPlayer(casinoNo) {
    let data = {
      casinoNo: casinoNo,
    };
    let url;
    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.casioToken_server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.casinoToken_property_name +
      '/saveCasinoDetails?appName=wbe';
    return this.httpService.post(url, data, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }
  public ValidateSecondaryCasinoPlayer(casinoNo) {
    let data = {
      casinoNo: casinoNo,
    };
    let url;
    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.casioToken_server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.casinoToken_property_name +
      '/saveCasinoDetails?appName=wbe';
    return this.httpService.post(url, data, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  async getLoyaltyToken(type?) {
    let casinoObject = JSON.parse(localStorage.getItem(`${this.tenantId}-${this.propertyId}-Casino`));
    let casino = casinoObject?.['casinoNumber'];
    let token =
      type === 'initial'
        ? localStorage.getItem(this.tenantId + '-' + this.propertyId + '-LoyaltyToken-' + casino) || ''
        : this.primaryPlayerLoyaltyToken;
    let header;
    let serviceHeaders = {};
    if (token) {
      serviceHeaders = {
        loyaltyToken: token,
      };
    }
    header = {
      headers: serviceHeaders,
    };
    let url = this.configservice.getCloudDomainName() + '/wbe-loyalty-service/loyalty/tenants/' + this.tenantId + '/casinoId/' + casino;
    await this.httpService
      .get(url, header)
      .toPromise()
      .then((tokenResponse: LoyalTokenResponse) => {
        console.log(tokenResponse);
        if (tokenResponse?.Success) {
          this.primaryPlayerLoyaltyToken = tokenResponse?.loyalToken;
          localStorage.setItem(this.tenantId + '-' + this.propertyId + '-LoyaltyToken-' + casino, tokenResponse?.loyalToken);

          if (type === 'initial') {
            clearInterval(this.primaryCasinoPlayerTokenInterval);
            this.primaryCasinoPlayerTokenInterval = setInterval(() => {
              this.getLoyaltyToken();
            }, 12 * 60 * 1000);
          }
        } else {
          // Error handling
          if (this.configservice.PropertyData.casinoValReq) {
            console.log(tokenResponse?.ErrorMessage);
            this.removePlayerToken();
            this.userData$.next(true);
            this.trackService.autoLogout.next('logout');
            // this.cmsService.logoutCasino();
            this.toastr.success('You are logged out. Kindly login to continue.');
          }
        }
      })
      .catch((err) => {
        // Error handling
        if (this.configservice.PropertyData.casinoValReq) {
          console.log(err['ErrorMessage']);
          this.removePlayerToken();
          this.userData$.next(true);
          this.trackService.autoLogout.next('logout');
          // this.cmsService.logoutCasino();
          this.toastr.success('You are logged out. Kindly login to continue.');
        }
      });
  }

  removePlayerToken() {
    let casinoObject = JSON.parse(localStorage.getItem(`${this.tenantId}-${this.propertyId}-Casino`));
    let casino = casinoObject?.['casinoNumber'];
    localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-LoyaltyToken-' + casino);
    clearInterval(this.primaryCasinoPlayerTokenInterval);
  }

  validatePin(pin, token) {
    var data = {
      pin: pin,
      token: token,
    };

    let url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.casioToken_server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.casinoToken_property_name +
      '/validateCasinoNoAndPin';
    return this.httpService.post(url, data, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }
}
